import React from 'react'
import { cn } from '@/lib/utils'

export const Breadcrumb: React.FC<React.HTMLAttributes<HTMLElement>> = ({ className, children, ...props }) => (
  <nav aria-label="breadcrumb" {...props}>
    <ol className={cn('flex items-center gap-1 text-sm text-muted-foreground', className)}>
      {children}
    </ol>
  </nav>
)

interface BreadcrumbItemProps extends React.HTMLAttributes<HTMLLIElement> {
  active?: boolean
}

export const BreadcrumbItem: React.FC<BreadcrumbItemProps> = ({ active, className, children, ...props }) => (
  <li
    className={cn(
      'flex items-center',
      active ? 'text-foreground font-medium' : 'after:content-["/"] after:mx-1.5 after:text-muted-foreground',
      className,
    )}
    {...props}
  >
    {children}
  </li>
)
